import "./PatInstallationIntegration.module.css";
import Header from "@/reusable_sections/Header";
import PatInstallation from "./sections/PatInstallation";
import InstallationProcess from "./sections/InstallationProcess";
import ProcessHub from "./sections/ProcessHub";
import ServicesOverview from "./sections/ServicesOverview";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function PatInstallationIntegrationPage() {
  return <div>
      <Header />
      <PatInstallation />
      <InstallationProcess />
      <ProcessHub />
      <ServicesOverview />
      <Consultation />
      <Footer />
    </div>;
}